export enum RequestStepTypeEnum {
  AdaptiveCard = 'adaptiveCard',
  GbgIdScan = 'gbgIdScan',
  FileDownload = 'fileDownload',
  FileUpload = 'fileUpload'
}
